import { doHttp } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../utils/config'

/**
 * 新增
 * @param params
 * @return {*}
 */
export function apiAdd (params) {
  return doHttp('/material/library/add.action', HTTP_TYPE_POST, params)
}

/**
 * 编辑
 * @param params
 * @return {*}
 */
export function apiEdit (params) {
  return doHttp('/material/library/add.action', HTTP_TYPE_POST, params)
}

/**
 * 列表
 * @param {*} params
 * @param {*} pageIndex
 * @param {*} pageSize
 * @param {*} type
 * @return {*}
 */
export function apiList (params, type, pageIndex = 1, pageSize = 20) {
  return doHttp(`/material/library/list.action?pageIndex=${pageIndex}&pageSize=${pageSize}&type=${type}`, HTTP_TYPE_POST, params)
}

/**
 * 删除
 * @param {*} id
 * @return {*}
 */
export function apiDelete(id) {
  let params = { id }
  return doHttp('/material/library/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 禁用
 * @param id
 * @return {*}
 */
export function apiSwitchStatus (id) {
  let params = { id }
  return doHttp('/material/library/status.action', HTTP_TYPE_GET, params)
}
